export default __webpack_public_path__ + "static/media/AliDay_Unit.eaa4bf57.png";